"use client";

import { c as _c } from "react/compiler-runtime";
import { OutsideLink } from "@/components/OutsideLink";
import { useLocale, useTranslations } from "next-intl";
import { getFriendlyLinkItems } from "./data";
import styles from "./page.module.sass";
export default function FriendlyLinkPage(_props) {
  const $ = _c(26);
  const t = useTranslations("friendlyLink");
  const locale = useLocale();
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== locale || $[1] !== t) {
    const items = getFriendlyLinkItems(locale);
    t4 = styles.container;
    t5 = "FriendlyLinkPage";
    t6 = "page.tsx";
    let t7;
    if ($[9] !== t) {
      t7 = t("title");
      $[9] = t;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    if ($[11] !== t7) {
      t2 = <h1 className={styles.title}>{t7}</h1>;
      $[11] = t7;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <hr style={{
        margin: "0 0 16px",
        border: 0,
        borderTop: "1px solid rgba(0, 0, 0, 0.12)"
      }} />;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    t0 = styles.list;
    t1 = items.map(_temp);
    $[0] = locale;
    $[1] = t;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[14] !== t0 || $[15] !== t1) {
    t7 = <ul className={t0}>{t1}</ul>;
    $[14] = t0;
    $[15] = t1;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t7) {
    t8 = <main>{t2}{t3}{t7}</main>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t8) {
    t9 = <div className={t4} data-sentry-component={t5} data-sentry-source-file={t6}>{t8}</div>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp(item) {
  return <li key={item.name}><div className={styles.item} style={{
      display: "flex",
      alignItems: "center",
      gap: 8,
      flexWrap: "wrap"
    }}><div><img style={{
          width: 16,
          height: 16,
          objectFit: "contain"
        }} src={typeof item.icon === "string" ? item.icon : item.icon?.src ?? `https://s2.googleusercontent.com/s2/favicons?domain_url=${item.url}`} alt={item.name} width={16} height={16} loading="lazy" decoding="async" /></div><div className={styles.item_name}>{item.name}</div><div className={styles.item_split}>-</div><div className={styles.item_url}><OutsideLink href={item.url} />{" "}<span aria-hidden="true" style={{
          fontSize: 12
        }}>↗</span></div></div></li>;
}